<div class="nlp-example-container">
    <div class="example-header">
        <img src="assets/nlp-component-images/Edit.svg" alt="" [style]="{'object-fit': 'contain', 'filter': filter, 'scale': '1.2'}">
        View NLP Example
    </div>
    <ng-container *ngIf="this.example_data.length > 0">
        <div class="example-container" *ngFor="let item of example_data; let i = index">
            <div class="example-history">
                <div class="date-line" *ngIf="decideShowDate(item,i)">
                    <div class="date">{{convertDate(item.date)}}</div>
                    <div class="clear-all" *ngIf="i == 0" (click)="clearAll()">Clear All</div>
                </div>
                <div class="content-box" (click)="emitExample(item)" *ngIf="item.text">
                    <div class="message-icon" [style]="{'filter': filter}"><img src="assets/nlp-component-images/ChatText.svg" alt="" style="filter: brightness(0);"></div>
                    <div class="text-box">
                        {{item.text}}
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    
</div>